import { createFileRoute } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { publicIdParam, resolveResource } from '@/app/route-ids';
import { PageViewPage } from '@/features/analytics/pages/page-view-page';

export const Route = createFileRoute('/_app/w/$workspaceId/analytics/$pageId/')({
    params: publicIdParam('pageId'),
    staticData: {
        crumbs: [{ label: 'shell.analytics', to: '/w/$workspaceId/analytics' }, { label: 'shell.crumbPage' }],
    },
    beforeLoad: async ({ context, params, location }) =>
        await resolveResource({
            ref: params.pageId,
            collection: 'analytics',
            location,
            read: async () => await call('getPage', { params: { ...context.workspaceScope, pageId: params.pageId } }),
        }),
    component: function AnalyticsPageRoute() {
        const { workspaceScope } = Route.useRouteContext();
        const { pageId } = Route.useParams();
        return <PageViewPage key={pageId} scope={workspaceScope} pageId={pageId} />;
    },
});
